import React from 'react'
import Navbar from '../inc/Navbar'
import { Link } from "react-router-dom";
import shortpant from "../images/cargo_shortpant.jpg";
import tshirt from "../images/t-shirt.jpg";
import Blazerkids from "../images/kids_blazer.jpg";
import Panjabikids from "../images/panjabi.jpg";
import kidsdress from "../images/girl kids dress.jpg";
import kidsfullpant from "../images/kids full pant.jpg";
import genjifrock from "../images/GENJI FROCK 1-1.jpg"


function Kidswear() {
  return (
    <div>
      <Navbar />
      <br />
      <br />
      <br />
      <br />
      <br />

      <div className='nadiacloth'>
        <div className="album py-1">
          <div className="container mt-4">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/" href="#">Home</Link></li>
                <li className="breadcrumb-item active" aria-current="page">Kids Wear</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>

      <div className="album py-1">
        <div className="container">
          <div className="row">
            
            <div className="col-md-6">
              <div className="d-flex justify-content-start align-items-center mb-2">
                <div className="col-md-6 me-2 mt-3">
                  <a href='kids_tshirt'>
                    <div className="card">
                      <img src={tshirt} className="card-img-top" alt="tshirt-kids" />
                      <div className="card-body">
                        <h5 className="card-title mb-1">T-Shirt</h5>
                        <p className="card-text">Best T-Shirt available</p>
                        <a href="kids_tshirt" className="learn">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                          <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                        </svg></a>
                      </div>
                    </div>
                  </a>
                </div>
                <div className="col-md-6 mt-3">
                <a href='kids_blazer'>
                  <div className="card">
                   
                    <img src={Blazerkids} className="card-img-top" alt="Blazer-kids" />
                    <div className="card-body">
                      <h5 className="card-title mb-1">Blazer</h5>
                      <p className="card-text">Best Blazer available</p>
                      <a href="kids_blazer" className="learn">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                      </svg></a>
                    </div>
                  </div>
                  </a>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="d-flex justify-content-start align-items-center mb-2">
                <div className="col-md-6  me-2 mt-3">
                  <a href='kids_panjabi'>
                  <div className="card" >
                    <img src={Panjabikids} className="card-img-top" alt="Panjabikids" />
                    <div className="card-body">
                      <h5 className="card-title mb-1">Panjabi </h5>
                      <p className="card-text">Best Panjabi available</p>
                      <a href="kids_panjabi" className="learn">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                      </svg></a>
                    </div>
                  </div>
                  </a>
                </div>

                <div className="col-md-6 me-2 mt-3">
                  <a href='kids-dress'>
                    <div className="card">
                      <img src={kidsdress} className="card-img-top" alt="baby_dress"/>
                      <div className="card-body">
                        <h5 className="card-title mb-1">Baby Dress</h5>
                        <p className="card-text">Best Baby dress available</p>
                        <a href="kids-dress" className="learn">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                          <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                        </svg></a>
                      </div>
                    </div>
                  </a>
                </div>

              </div>

            </div>





          </div>
        </div>
      </div>

      <div className="album py-0">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="d-flex justify-content-start align-items-center mb-2">
                <div className="col-md-6  me-2 mt-3">
                  <a href='kids_shortpant'>
                  <div className="card" >
                    <img src={shortpant} className="card-img-top" alt="shortpant"/>
                    <div className="card-body">
                      <h5 className="card-title mb-1">Cargo Short </h5>
                      <p className="card-text">Best short pant available</p>
                      <a href="kids_shortpant" className="learn">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                      </svg></a>
                    </div>
                  </div>
                  </a>
                </div>
                 <div className="col-md-6  me-2 mt-3">
                  <a href='kids-fullpant'>
                  <div className="card" >
                    <img src={kidsfullpant} className="card-img-top" alt="kidsfullpant"/>
                    <div className="card-body">
                      <h5 className="card-title mb-1">Full Pant </h5>
                      <p className="card-text">Best full pant available</p>
                      <a href="kids-fullpant" className="learn">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                      </svg></a>
                    </div>
                  </div>
                  </a>
                </div>
                
              </div>
              
            </div>
             <div className="col-md-6">
              <div className="d-flex justify-content-start align-items-center mb-2">
                <div className="col-md-6  me-2 mt-3">
                  <a href='kidsfrock'>
                  <div className="card" >
                    <img src={genjifrock} className="card-img-top" alt="genjifrock"/>
                    <div className="card-body">
                      <h5 className="card-title mb-1">Kids Frock</h5>
                      <p className="card-text">Best Frock available</p>
                      <a href="kidsfrock" className="learn">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                      </svg></a>
                    </div>
                  </div>
                  </a>
                </div>
               
                
              </div>
              
            </div>






          </div>
        </div>
      </div>
     
      <br />
    </div>
  )
}

export default Kidswear